import apiClient from "../helpers/apiClient";
import { handleApiError } from "../utils/handleApiError";

/* Payments */
export async function getMyPaymentMethods(params:any){
    try {
        const { data } = await apiClient.get(`/members/payment-methods/list/`,{params: params});
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function createPaymentMethod(data: any) {
    try {
        const response = await apiClient.post(`/members/payment-methods/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}

export async function deletePaymentMethod(id:number,data: any) {
    try {
        const response = await apiClient.delete(`/members/payment-methods/${id}/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}

/* Payouts */
export async function getMyPayoutMethods(params:any){
    try {
        const { data } = await apiClient.get(`/members/payout-methods/list/`,{params: params});
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export async function editPayoutMethods(id:number,params:any){
    try {
        const { data } = await apiClient.put(`/members/payout-methods/${id}/`,params);
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function createPayoutMethod(data: any) {
    try {
        const response = await apiClient.post(`/members/payout-methods/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}

export async function deletePayoutMethod(id:number,data: any) {
    try {
        const response = await apiClient.delete(`/members/payout-methods/${id}/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}

/* servicios simulados ya que no existen datos */
export async function getMembershipCredits(params:any){
    try {
        const { data } = await apiClient.get(`/members/credits/`,{params: params});
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getMembershipFinancialOverview(params:any){
    try {
        const { data } = await apiClient.get(`/members/financial-overview/`,{params: params});
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}